import { type RefObject, useEffect, useRef } from "react";

/** Scrolls the referenced element back to the top whenever `trigger` changes. */
export function useScrollToTop<T extends HTMLElement>(trigger: unknown): RefObject<T | null> {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.scrollTo({ top: 0 });
  }, [trigger]);
  return ref;
}
